// extracted by mini-css-extract-plugin
export default {"mainterms":"Tearms_mainterms__2kjRJ"};